import { render, staticRenderFns } from "./CounterIncrease.vue?vue&type=template&id=cf40ebd2"
import script from "./CounterIncrease.vue?vue&type=script&lang=js"
export * from "./CounterIncrease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports